module.exports = __webpack_public_path__ + "img/Right.aaf4cb26.svg";